const BASE_PATH = "app/admin/users/";

export const SET_USERS = `${BASE_PATH}set-users`;
